(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[134],{

/***/ 830:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return __webpack_require__(51);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _GridElement__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5299);
/* harmony import */ var _GridWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2409);
/* harmony import */ var _public_bg_graphics_arrows_in_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9248);





var BackgroundGraphic = function(param) {
    var _bgHeight = param.bgHeight, bgHeight = _bgHeight === void 0 ? 70 : _bgHeight, _align = param.align, align = _align === void 0 ? "right" : _align;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GridWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: -1
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GridElement__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            gridLayout: align === "right" ? [
                [
                    961,
                    10,
                    7
                ],
                [
                    1401,
                    19,
                    14
                ], 
            ] : [
                [
                    961,
                    1,
                    7
                ],
                [
                    1401,
                    1,
                    14
                ], 
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "relative",
                    height: "".concat(bgHeight, "vh")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: _public_bg_graphics_arrows_in_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                    alt: "background arrows",
                    layout: "fill",
                    objectFit: "contain",
                    priority: true
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundGraphic);


/***/ }),

/***/ 7443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _BackgroundGraphic__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _BackgroundGraphic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);



/***/ }),

/***/ 51:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ NewsHomePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storyblok_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9036);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9403);
/* harmony import */ var _components_BackgroundGraphic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7443);
/* harmony import */ var _components_GridWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2409);
/* harmony import */ var _components_GridElement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5299);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4538);
/* harmony import */ var _styles_News_module_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9933);
/* harmony import */ var _styles_News_module_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_News_module_css__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7572);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_BlogPost_BlogPost__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1256);
/* harmony import */ var _components_Cta_Cta__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3499);















var sbQueryParams = {
    starts_with: "news",
    is_startpage: "false",
    resolve_links: "url",
    sort_by: "first_published_at:desc",
    per_page: 13
};
var __N_SSG = true;
function NewsHomePage(param) {
    var story = param.story, isTestEnv = param.isTestEnv;
    var ref;
    story = (0,_storyblok_react__WEBPACK_IMPORTED_MODULE_2__/* .useStoryblokState */ .f0)(story);
    var storyblokApi = (0,_storyblok_react__WEBPACK_IMPORTED_MODULE_2__/* .getStoryblokApi */ .bS)();
    var ref1 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_10__/* .useInfiniteQuery */ .N)([
        "news"
    ], function(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        return storyblokApi.get("cdn/stories", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, sbQueryParams), {
            page: pageParam,
            version: isTestEnv ? "draft" : "published"
        }));
    }, {
        getNextPageParam: function(lastPage, pages) {
            if (lastPage.total / lastPage.perPage > pages.length) {
                return pages.length + 1;
            } else {
                return undefined;
            }
        }
    }), newsStories = ref1.data, fetchNextPage = ref1.fetchNextPage, hasNextPage = ref1.hasNextPage, isFetchingNextPage = ref1.isFetchingNextPage, isLoading = ref1.isLoading;
    var isDesktop = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_6__/* .useWindowSize */ .i)().isDesktop;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_GridWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (_styles_News_module_css__WEBPACK_IMPORTED_MODULE_13___default().news),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_GridElement__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            gridLayout: [
                [
                    1401,
                    4,
                    26
                ]
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BackgroundGraphic__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    align: "right"
                }),
                (newsStories === null || newsStories === void 0 ? void 0 : newsStories.pages) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogPost_BlogPost__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    isLarge: true,
                    ctaType: "button",
                    blok: {
                        _uid: newsStories === null || newsStories === void 0 ? void 0 : newsStories.pages[0].data.stories[0].content._uid,
                        component: newsStories === null || newsStories === void 0 ? void 0 : newsStories.pages[0].data.stories[0].content.component,
                        image: newsStories === null || newsStories === void 0 ? void 0 : newsStories.pages[0].data.stories[0].content.preview_image,
                        meta_title: newsStories === null || newsStories === void 0 ? void 0 : newsStories.pages[0].data.stories[0].content.preview_info_title,
                        title: newsStories === null || newsStories === void 0 ? void 0 : newsStories.pages[0].data.stories[0].content.preview_title,
                        intro: newsStories === null || newsStories === void 0 ? void 0 : newsStories.pages[0].data.stories[0].content.preview_intro,
                        cta_link: [
                            {
                                name: "Read more",
                                link: {
                                    linktype: "story",
                                    story: {
                                        full_slug: newsStories === null || newsStories === void 0 ? void 0 : newsStories.pages[0].data.stories[0].full_slug
                                    }
                                }
                            }, 
                        ]
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_14__/* .motion.section */ .E.section, {
                    className: (_styles_News_module_css__WEBPACK_IMPORTED_MODULE_13___default().blogPostsSmall),
                    viewport: {
                        once: false
                    },
                    initial: {
                        opacity: isDesktop ? 1 : 0.3,
                        transform: isDesktop ? "translate(0, 0)" : "translate(0, 6rem)"
                    },
                    whileInView: {
                        opacity: 1,
                        transform: "translate(0, 0)"
                    },
                    transition: {
                        ease: "linear",
                        duration: 0.8
                    },
                    children: newsStories === null || newsStories === void 0 ? void 0 : (ref = newsStories.pages) === null || ref === void 0 ? void 0 : ref.map(function(group, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: group.data.stories.map(function(story, n) {
                                if (i === 0 && n === 0) return;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    href: story.full_slug,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: (_styles_News_module_css__WEBPACK_IMPORTED_MODULE_13___default().blogPostsSmallLink),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogPost_BlogPost__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            isLarge: false,
                                            blok: {
                                                _uid: story.content._uid,
                                                component: story.content.component,
                                                image: story.content.preview_image,
                                                meta_title: story.content.preview_info_title,
                                                title: story.content.preview_title,
                                                intro: story.content.preview_intro
                                            }
                                        })
                                    })
                                }, "".concat(story.content._uid, "-").concat(n));
                            })
                        }, "".concat(group.data.stories[0].uuid, "-").concat(i));
                    })
                }),
                (isLoading || isFetchingNextPage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogPost_BlogPost__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            isLoading: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogPost_BlogPost__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            isLoading: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogPost_BlogPost__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            isLoading: true
                        })
                    ]
                }),
                hasNextPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_News_module_css__WEBPACK_IMPORTED_MODULE_13___default().buttonWrapper),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cta_Cta__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        name: "Show more",
                        onClick: function() {
                            return fetchNextPage();
                        },
                        disabled: isFetchingNextPage
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 9933:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__l_WIF","buttonWrapper":"News_buttonWrapper__QeLP8","blogPostsSmallLink":"News_blogPostsSmallLink__LWBa_","blogPostsSmall":"News_blogPostsSmall__n1UA8"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(830); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);